/* eslint-disable import/prefer-default-export */
import { handleBlob, preProcessingResponse } from './helpers'
import {
  APIRequest,
  APIResponse,
  makeExternalRequest,
  makeRequest
} from './make.request'
import type { UnusedAccessReportReq } from './services/graphQueryMgr.service'
import type { DownloadReportReq } from './services/reportmanager.service'

export interface GetReportReq {
  suite_id: string | number
}

export const getReport = (params: GetReportReq) =>
  makeRequest({
    port: '30103',
    url: '/v1/report',
    method: 'GET',
    params
  }).then(handleBlob)

export const downloadReport = (params: DownloadReportReq) =>
  makeRequest({
    port: '30103',
    url: `/v1/reports/download`,
    method: 'GET',
    params
  }).then(handleBlob)

export const getUnusedAccessReport = (params: UnusedAccessReportReq) =>
  makeRequest({
    port: '30103',
    url: '/v1/graph-querymgr/unused-accesses/report',
    method: 'POST',
    reqOptions: {
      body: JSON.stringify(params)
    }
  }).then(handleBlob)

interface GetIdentityNowSourcesCacheItem {
  id: string
  type: string
  name: string
}

export type GetIdentityNowSourcesCacheResp = GetIdentityNowSourcesCacheItem[]

export const getIdentityNowSourcesCache = ({
  urlRequest
}: APIRequest<{}, { id: string }, GetCorrelatedIdentitiesResp>): Promise<
  APIResponse<GetIdentityNowSourcesCacheResp>
> => {
  return makeExternalRequest({
    url: `${urlRequest}/v3/sources`,
    method: 'GET',
    reqOptions: {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      signal: null
    }
  })
    .then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetIdentityNowSourcesCacheResp>>()
          .then<APIResponse<GetIdentityNowSourcesCacheResp>>(
            preProcessingResponse
          )
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
    .catch(ex => ex)
}

export interface GetCorrelatedIdentitiesResp {
  displayName?: string
  emailAddress?: string
  manager?: string
  riskScore?: number
  attributes?: {
    uid?: string
    firstname?: string
    cloudAuthoritativeSource?: string
    cloudStatus?: string
    displayName?: string
    internalCloudStatus?: string
    lastSyncDate?: string
    email?: string
    lastname?: string
  }
  isManager?: boolean
  profileRole?: string
  profileId?: string
  stateRole?: string
  detectedRoles?: string[]
  lastRefresh?: string
  lifecycleStateManuallyUpdated?: boolean
  processingState?: null
  cloudStatus?: string
  id?: string
  name?: string
  meta?: {
    created?: string
    modified?: string
    type?: string
  }
}

export const getCorrelatedIdentities = ({
  params,
  options,
  queryVars,
  urlRequest
}: APIRequest<{}, { id: string }, GetCorrelatedIdentitiesResp>): Promise<
  APIResponse<GetCorrelatedIdentitiesResp>
> => {
  return makeExternalRequest({
    url: `${urlRequest}/mice/api/v1/identities/${queryVars.id}`,
    method: 'GET',
    reqOptions: options,
    params
  })
    .then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetCorrelatedIdentitiesResp>>()
          .then<APIResponse<GetCorrelatedIdentitiesResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
    .catch(ex => ex)
}
